/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { CreateWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPostParams } from '../models/createWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPostParams';

import type { DocumentDistributionItem } from '../models/documentDistributionItem';

import type { DocumentDistributionReport } from '../models/documentDistributionReport';

import type { DocumentDistributionSettingsResponse } from '../models/documentDistributionSettingsResponse';

import type { DocumentDistributionSettingsUpdate } from '../models/documentDistributionSettingsUpdate';

import type { DocumentSendDefaults } from '../models/documentSendDefaults';

import type { GetDistributionReportApiV1DocumentDistributionReportGetParams } from '../models/getDistributionReportApiV1DocumentDistributionReportGetParams';

import type { GetDistributionSettingsApiV1DocumentDistributionSettingsGetParams } from '../models/getDistributionSettingsApiV1DocumentDistributionSettingsGetParams';

import type { GetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetParams } from '../models/getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetParams';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { ListDocumentDistributionsApiV1DocumentDistributionDistributionsGetParams } from '../models/listDocumentDistributionsApiV1DocumentDistributionDistributionsGetParams';

import type { UpdateDistributionSettingsApiV1DocumentDistributionSettingsPutParams } from '../models/updateDistributionSettingsApiV1DocumentDistributionSettingsPutParams';

import type { WhatsAppShareResponse } from '../models/whatsAppShareResponse';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * @summary Get Distribution Settings
 */
export const getDistributionSettingsApiV1DocumentDistributionSettingsGet = (
  params?: GetDistributionSettingsApiV1DocumentDistributionSettingsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<DocumentDistributionSettingsResponse>({
    url: `/api/v1/document-distribution/settings`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetDistributionSettingsApiV1DocumentDistributionSettingsGetQueryKey =
  (
    params?: GetDistributionSettingsApiV1DocumentDistributionSettingsGetParams
  ) => {
    return [
      `/api/v1/document-distribution/settings`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetDistributionSettingsApiV1DocumentDistributionSettingsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: GetDistributionSettingsApiV1DocumentDistributionSettingsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDistributionSettingsApiV1DocumentDistributionSettingsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
        >
      >
    > = ({ signal }) =>
      getDistributionSettingsApiV1DocumentDistributionSettingsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDistributionSettingsApiV1DocumentDistributionSettingsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
      >
    >
  >;
export type GetDistributionSettingsApiV1DocumentDistributionSettingsGetQueryError =
  HTTPValidationError;

export function useGetDistributionSettingsApiV1DocumentDistributionSettingsGet<
  TData = Awaited<
    ReturnType<
      typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetDistributionSettingsApiV1DocumentDistributionSettingsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDistributionSettingsApiV1DocumentDistributionSettingsGet<
  TData = Awaited<
    ReturnType<
      typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetDistributionSettingsApiV1DocumentDistributionSettingsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDistributionSettingsApiV1DocumentDistributionSettingsGet<
  TData = Awaited<
    ReturnType<
      typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetDistributionSettingsApiV1DocumentDistributionSettingsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Distribution Settings
 */

export function useGetDistributionSettingsApiV1DocumentDistributionSettingsGet<
  TData = Awaited<
    ReturnType<
      typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetDistributionSettingsApiV1DocumentDistributionSettingsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDistributionSettingsApiV1DocumentDistributionSettingsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDistributionSettingsApiV1DocumentDistributionSettingsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Distribution Settings
 */
export const updateDistributionSettingsApiV1DocumentDistributionSettingsPut = (
  documentDistributionSettingsUpdate: DocumentDistributionSettingsUpdate,
  params?: UpdateDistributionSettingsApiV1DocumentDistributionSettingsPutParams
) => {
  return customInstance<DocumentDistributionSettingsResponse>({
    url: `/api/v1/document-distribution/settings`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: documentDistributionSettingsUpdate,
    params
  });
};

export const getUpdateDistributionSettingsApiV1DocumentDistributionSettingsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDistributionSettingsApiV1DocumentDistributionSettingsPut
        >
      >,
      TError,
      {
        data: DocumentDistributionSettingsUpdate;
        params?: UpdateDistributionSettingsApiV1DocumentDistributionSettingsPutParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDistributionSettingsApiV1DocumentDistributionSettingsPut
      >
    >,
    TError,
    {
      data: DocumentDistributionSettingsUpdate;
      params?: UpdateDistributionSettingsApiV1DocumentDistributionSettingsPutParams;
    },
    TContext
  > => {
    const mutationKey = [
      'updateDistributionSettingsApiV1DocumentDistributionSettingsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDistributionSettingsApiV1DocumentDistributionSettingsPut
        >
      >,
      {
        data: DocumentDistributionSettingsUpdate;
        params?: UpdateDistributionSettingsApiV1DocumentDistributionSettingsPutParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return updateDistributionSettingsApiV1DocumentDistributionSettingsPut(
        data,
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDistributionSettingsApiV1DocumentDistributionSettingsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDistributionSettingsApiV1DocumentDistributionSettingsPut
      >
    >
  >;
export type UpdateDistributionSettingsApiV1DocumentDistributionSettingsPutMutationBody =
  DocumentDistributionSettingsUpdate;
export type UpdateDistributionSettingsApiV1DocumentDistributionSettingsPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Distribution Settings
 */
export const useUpdateDistributionSettingsApiV1DocumentDistributionSettingsPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateDistributionSettingsApiV1DocumentDistributionSettingsPut
          >
        >,
        TError,
        {
          data: DocumentDistributionSettingsUpdate;
          params?: UpdateDistributionSettingsApiV1DocumentDistributionSettingsPutParams;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateDistributionSettingsApiV1DocumentDistributionSettingsPut
      >
    >,
    TError,
    {
      data: DocumentDistributionSettingsUpdate;
      params?: UpdateDistributionSettingsApiV1DocumentDistributionSettingsPutParams;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateDistributionSettingsApiV1DocumentDistributionSettingsPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary List Document Distributions
 */
export const listDocumentDistributionsApiV1DocumentDistributionDistributionsGet =
  (
    params: ListDocumentDistributionsApiV1DocumentDistributionDistributionsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<DocumentDistributionItem[]>({
      url: `/api/v1/document-distribution/distributions`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListDocumentDistributionsApiV1DocumentDistributionDistributionsGetQueryKey =
  (
    params?: ListDocumentDistributionsApiV1DocumentDistributionDistributionsGetParams
  ) => {
    return [
      `/api/v1/document-distribution/distributions`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListDocumentDistributionsApiV1DocumentDistributionDistributionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: ListDocumentDistributionsApiV1DocumentDistributionDistributionsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDocumentDistributionsApiV1DocumentDistributionDistributionsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
        >
      >
    > = ({ signal }) =>
      listDocumentDistributionsApiV1DocumentDistributionDistributionsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDocumentDistributionsApiV1DocumentDistributionDistributionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
      >
    >
  >;
export type ListDocumentDistributionsApiV1DocumentDistributionDistributionsGetQueryError =
  HTTPValidationError;

export function useListDocumentDistributionsApiV1DocumentDistributionDistributionsGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ListDocumentDistributionsApiV1DocumentDistributionDistributionsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDocumentDistributionsApiV1DocumentDistributionDistributionsGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ListDocumentDistributionsApiV1DocumentDistributionDistributionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDocumentDistributionsApiV1DocumentDistributionDistributionsGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ListDocumentDistributionsApiV1DocumentDistributionDistributionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Document Distributions
 */

export function useListDocumentDistributionsApiV1DocumentDistributionDistributionsGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ListDocumentDistributionsApiV1DocumentDistributionDistributionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentDistributionsApiV1DocumentDistributionDistributionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDocumentDistributionsApiV1DocumentDistributionDistributionsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Issue a public link for sharing a document over WhatsApp.

Generic across producing modules: the registered distributable type carries
its own ``auth_module``, so this single route enforces the same module-access
bar as the module's own email-distribute route. ``link_format`` picks what
the shared link points at: ``'view'`` (default) the branded view page, or
``'pdf'`` the direct PDF download. Returns the public link plus a
ready-to-send plain-text summary; the wa.me hand-off happens client-side.

The share language follows the recipient: an explicit ``lang`` wins, else the
recipient contact's preferred language, else ``fallback_lang`` (the sender's
current UI language), so the WhatsApp summary matches the contact's language.
 * @summary Create Whatsapp Share
 */
export const createWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPost =
  (
    documentType: string,
    documentId: string,
    params?: CreateWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPostParams,
    signal?: AbortSignal
  ) => {
    return customInstance<WhatsAppShareResponse>({
      url: `/api/v1/document-distribution/${documentType}/${documentId}/whatsapp-link`,
      method: 'POST',
      params,
      signal
    });
  };

export const getCreateWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPost
        >
      >,
      TError,
      {
        documentType: string;
        documentId: string;
        params?: CreateWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPostParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPost
      >
    >,
    TError,
    {
      documentType: string;
      documentId: string;
      params?: CreateWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPostParams;
    },
    TContext
  > => {
    const mutationKey = [
      'createWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPost
        >
      >,
      {
        documentType: string;
        documentId: string;
        params?: CreateWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPostParams;
      }
    > = (props) => {
      const { documentType, documentId, params } = props ?? {};

      return createWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPost(
        documentType,
        documentId,
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPost
      >
    >
  >;

export type CreateWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Whatsapp Share
 */
export const useCreateWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPost
          >
        >,
        TError,
        {
          documentType: string;
          documentId: string;
          params?: CreateWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPostParams;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPost
      >
    >,
    TError,
    {
      documentType: string;
      documentId: string;
      params?: CreateWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPostParams;
    },
    TContext
  > => {
    const mutationOptions =
      getCreateWhatsappShareApiV1DocumentDistributionDocumentTypeDocumentIdWhatsappLinkPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Pre-fill values for the shared SendDocumentDialog (recipients, subject, message).

Generic across producing modules: the registered distributable type carries
its own ``auth_module``, so this one route enforces the same module-access bar
as the module's own email-distribute route. Recipients come from the type's
``get_metadata``; the subject defaults to ``"{title} {number}"`` and ``message``
to the localized cover note that would otherwise be sent silently.

The send language follows the recipient: an explicit ``lang`` wins, else the
recipient contact's preferred language, else ``fallback_lang`` (the sender's
current UI language), else the requesting user's stored preference (``en``
last). It's returned so the dialog forwards it and the email/PDF render in the
same language as the message.
 * @summary Get Document Send Defaults
 */
export const getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet =
  (
    documentType: string,
    documentId: string,
    params?: GetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<DocumentSendDefaults>({
      url: `/api/v1/document-distribution/${documentType}/${documentId}/send-defaults`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetQueryKey =
  (
    documentType?: string,
    documentId?: string,
    params?: GetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetParams
  ) => {
    return [
      `/api/v1/document-distribution/${documentType}/${documentId}/send-defaults`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
      >
    >,
    TError = HTTPValidationError
  >(
    documentType: string,
    documentId: string,
    params?: GetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetQueryKey(
        documentType,
        documentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
        >
      >
    > = ({ signal }) =>
      getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet(
        documentType,
        documentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(documentType && documentId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
      >
    >
  >;
export type GetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetQueryError =
  HTTPValidationError;

export function useGetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet<
  TData = Awaited<
    ReturnType<
      typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
    >
  >,
  TError = HTTPValidationError
>(
  documentType: string,
  documentId: string,
  params:
    | undefined
    | GetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet<
  TData = Awaited<
    ReturnType<
      typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
    >
  >,
  TError = HTTPValidationError
>(
  documentType: string,
  documentId: string,
  params?: GetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet<
  TData = Awaited<
    ReturnType<
      typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
    >
  >,
  TError = HTTPValidationError
>(
  documentType: string,
  documentId: string,
  params?: GetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Document Send Defaults
 */

export function useGetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet<
  TData = Awaited<
    ReturnType<
      typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
    >
  >,
  TError = HTTPValidationError
>(
  documentType: string,
  documentId: string,
  params?: GetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDocumentSendDefaultsApiV1DocumentDistributionDocumentTypeDocumentIdSendDefaultsGetQueryOptions(
      documentType,
      documentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Distribution Report
 */
export const getDistributionReportApiV1DocumentDistributionReportGet = (
  params?: GetDistributionReportApiV1DocumentDistributionReportGetParams,
  signal?: AbortSignal
) => {
  return customInstance<DocumentDistributionReport>({
    url: `/api/v1/document-distribution/report`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetDistributionReportApiV1DocumentDistributionReportGetQueryKey =
  (params?: GetDistributionReportApiV1DocumentDistributionReportGetParams) => {
    return [
      `/api/v1/document-distribution/report`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetDistributionReportApiV1DocumentDistributionReportGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDistributionReportApiV1DocumentDistributionReportGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetDistributionReportApiV1DocumentDistributionReportGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDistributionReportApiV1DocumentDistributionReportGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDistributionReportApiV1DocumentDistributionReportGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDistributionReportApiV1DocumentDistributionReportGet
        >
      >
    > = ({ signal }) =>
      getDistributionReportApiV1DocumentDistributionReportGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDistributionReportApiV1DocumentDistributionReportGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDistributionReportApiV1DocumentDistributionReportGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDistributionReportApiV1DocumentDistributionReportGet>
    >
  >;
export type GetDistributionReportApiV1DocumentDistributionReportGetQueryError =
  HTTPValidationError;

export function useGetDistributionReportApiV1DocumentDistributionReportGet<
  TData = Awaited<
    ReturnType<typeof getDistributionReportApiV1DocumentDistributionReportGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetDistributionReportApiV1DocumentDistributionReportGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDistributionReportApiV1DocumentDistributionReportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDistributionReportApiV1DocumentDistributionReportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDistributionReportApiV1DocumentDistributionReportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDistributionReportApiV1DocumentDistributionReportGet<
  TData = Awaited<
    ReturnType<typeof getDistributionReportApiV1DocumentDistributionReportGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDistributionReportApiV1DocumentDistributionReportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDistributionReportApiV1DocumentDistributionReportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDistributionReportApiV1DocumentDistributionReportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDistributionReportApiV1DocumentDistributionReportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDistributionReportApiV1DocumentDistributionReportGet<
  TData = Awaited<
    ReturnType<typeof getDistributionReportApiV1DocumentDistributionReportGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDistributionReportApiV1DocumentDistributionReportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDistributionReportApiV1DocumentDistributionReportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Distribution Report
 */

export function useGetDistributionReportApiV1DocumentDistributionReportGet<
  TData = Awaited<
    ReturnType<typeof getDistributionReportApiV1DocumentDistributionReportGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDistributionReportApiV1DocumentDistributionReportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDistributionReportApiV1DocumentDistributionReportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDistributionReportApiV1DocumentDistributionReportGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
